module.exports = {
  routes: [
    {
      path: '/administration',
      component: require('./pages/Administration').default,
      meta: { requiresAuth: true, requiresEmployee: true },
      children: [
        {
          path: '',
          name: 'administration',
          component: require('./pages/Statistics').default,
          meta: { requiresAuth: true, requiresEmployee: true }
        },
        {
          path: 'students',
          name: 'administration.students',
          component: require('./pages/students/List').default,
          meta: { requiresAuth: true, requiresEmployee: true },
          children: [
            {
              path: 'active',
              name: 'administration.students.active',
              meta: {
                requiresAuth: true,
                requiresEmployee: true,
                filter: 'active'
              }
            },
            {
              path: 'new',
              name: 'administration.students.new',
              meta: {
                requiresAuth: true,
                requiresEmployee: true,
                filter: 'new-from-signup'
              }
            },
            {
              path: 'applications',
              name: 'administration.students.applications',
              meta: {
                requiresAuth: true,
                requiresEmployee: true,
                filter: 'applications'
              }
            }
          ]
        },
        {
          path: 'students/:id',
          component: require('./pages/students/Detail').default,
          name: 'administration.students.detail',
          meta: { requiresAuth: true, requiresEmployee: true }
        },
        {
          path: 'customers',
          name: 'administration.customers',
          component: require('./pages/customers/List').default,
          meta: { requiresAuth: true, requiresEmployee: true },
          children: [
            {
              path: 'active-projects',
              name: 'administration.customers.activeProjects',
              meta: {
                requiresAuth: true,
                requiresEmployee: true,
                filter: 'active-projects'
              }
            }
          ]
        },
        {
          path: 'customers/:id',
          component: require('./pages/customers/Detail').default,
          name: 'administration.customers.detail',
          meta: { requiresAuth: true, requiresEmployee: true }
        },
        {
          path: 'projects',
          name: 'administration.projects',
          component: require('./pages/projects/List').default,
          meta: { requiresAuth: true, requiresEmployee: true },
          children: [
            {
              path: 'active',
              name: 'administration.projects.open',
              meta: {
                requiresAuth: true,
                requiresEmployee: true,
                filter: 'open'
              },
              children: [
                {
                  path: 'project-created',
                  name: 'administration.projects.project-created',
                  meta: {
                    requiresAuth: true,
                    requiresEmployee: true,
                    filter: 'project-created'
                  }
                },
                {
                  path: 'project-clarification',
                  name: 'administration.projects.project-clarification',
                  meta: {
                    requiresAuth: true,
                    requiresEmployee: true,
                    filter: 'project-clarification'
                  }
                },
                {
                  path: 'project-offer-posted',
                  name: 'administration.projects.project-offer-posted',
                  meta: {
                    requiresAuth: true,
                    requiresEmployee: true,
                    filter: 'project-offer-posted'
                  }
                },
                {
                  path: 'project-offer-accepted',
                  name: 'administration.projects.project-offer-accepted',
                  meta: {
                    requiresAuth: true,
                    requiresEmployee: true,
                    filter: 'project-offer-accepted'
                  }
                },
                {
                  path: 'employee-closed-project',
                  name: 'administration.projects.employee-closed-project',
                  meta: {
                    requiresAuth: true,
                    requiresEmployee: true,
                    filter: 'employee-closed-project'
                  }
                },
                {
                  path: 'student-closed-project',
                  name: 'administration.projects.student-closed-project',
                  meta: {
                    requiresAuth: true,
                    requiresEmployee: true,
                    filter: 'student-closed-project'
                  }
                },
                {
                  path: 'customer-closed-project',
                  name: 'administration.projects.customer-closed-project',
                  meta: {
                    requiresAuth: true,
                    requiresEmployee: true,
                    filter: 'customer-closed-project'
                  }
                },
                {
                  path: 'project-finalized',
                  name: 'administration.projects.project-finalized',
                  meta: {
                    requiresAuth: true,
                    requiresEmployee: true,
                    filter: 'project-finalized'
                  }
                }
              ]
            },
            {
              path: 'applications',
              name: 'administration.projects.closed',
              meta: {
                requiresAuth: true,
                requiresEmployee: true,
                filter: 'closed'
              }
            }
          ]
        },
        {
          path: 'employees',
          name: 'administration.employees',
          component: require('./pages/employees/List').default,
          meta: { requiresAuth: true, requiresEmployee: true }
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/taskflex/administration/routes.js